export default "__VITE_ASSET__BMowx$Ag__"